module.exports = __webpack_public_path__ + "img/bike_nosignal.936620df.svg";